import { useState } from 'react';
import { SideMenuModal } from './SideMenuModal';
import { colors } from '../constants/colors';

interface SellerNotesModalProps {
  onClose: () => void;
  initialNotes: string;
  onSave: (notes: string) => void;
}

export function SellerNotesModal({ onClose, initialNotes, onSave }: SellerNotesModalProps) {
  const [value, setValue] = useState(initialNotes);
  const [focused, setFocused] = useState(false);

  const handleSave = () => {
    onSave(value);
    onClose();
  };

  return (
    <SideMenuModal title="Show Notes" onClose={onClose}>
      <div style={{ fontSize: 14, color: colors.gray[600], lineHeight: 1.5, marginBottom: 12 }}>
        Pinned notes appear on every viewer's screen. Use these for shipping info, welcome messages, or quick rules.
      </div>

      <textarea
        value={value}
        onChange={e => setValue(e.target.value)}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        maxLength={1000}
        style={{
          width: '100%',
          minHeight: 120,
          padding: 12,
          borderRadius: 10,
          border: `1px solid ${focused ? colors.brand.blue : colors.gray[200]}`,
          fontSize: 14,
          lineHeight: 1.5,
          fontFamily: 'inherit',
          resize: 'vertical',
          outline: 'none',
          boxSizing: 'border-box',
        }}
      />

      <div style={{ textAlign: 'right', fontSize: 11, color: colors.gray[400], marginTop: 6 }}>
        {value.length} / 1000
      </div>

      <div style={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 8,
        marginTop: 16,
        paddingTop: 16,
        borderTop: `1px solid ${colors.gray[200]}`,
      }}>
        <button
          onClick={onClose}
          style={{
            padding: '8px 14px',
            background: colors.gray[100],
            border: 'none',
            borderRadius: 8,
            fontSize: 13,
            fontWeight: 600,
            color: colors.ink.black,
            cursor: 'pointer',
          }}
        >
          Cancel
        </button>
        <button
          onClick={handleSave}
          style={{
            padding: '8px 16px',
            background: colors.accent.purple,
            color: colors.white,
            border: 'none',
            borderRadius: 8,
            fontSize: 13,
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          Save
        </button>
      </div>
    </SideMenuModal>
  );
}
